import useDataLakeTables from "data-lake/preview/storage-types/external/hooks/useDataLakeTables";
const useDataLakeTableOptions = (dataLakeId) => {
  const { data, isLoading } = useDataLakeTables(dataLakeId);
  return {
    data: data.map((tableInfo) => ({
      label: tableInfo.name,
      value: tableInfo.id,
      catalog: tableInfo.catalog,
      schema: tableInfo.schema
    })),
    isLoading
  };
};
export default useDataLakeTableOptions;
